export default {
  status: `{value, select,
    PENDING {En attente de programmation}
    PLANNED {Programmé le {date, date, medium} à {date, time, short}}
    other {Annulé}
  }`,
};
